import i18next, { TOptions } from 'i18next';

const i18n = (key: string, options?: TOptions): string => {
  return i18next.t(key, options);
};

export default i18n;
